import { render, staticRenderFns } from "./picDataDetails.vue?vue&type=template&id=4db12ec1&scoped=true"
import script from "./picDataDetails.vue?vue&type=script&lang=js"
export * from "./picDataDetails.vue?vue&type=script&lang=js"
import style0 from "./picDataDetails.vue?vue&type=style&index=0&id=4db12ec1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db12ec1",
  null
  
)

export default component.exports